import 'reflect-metadata';
import * as Sentry from '@sentry/react-router';
import { startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';

import {
	IS_SENTRY_ENABLED,
	SENTRY_DSN,
	BASE_URL,
	ENVIRONMENT,
	SENTRY_REPLAY_SAMPLE_RATE,
	SENTRY_TRACE_SAMPLE_RATE,
} from '@/constants';

if (IS_SENTRY_ENABLED) {
	Sentry.init({
		dsn: SENTRY_DSN,
		environment: `${ENVIRONMENT}`,
		tracePropagationTargets: ['localhost', BASE_URL],
		integrations: [
			Sentry.reactRouterTracingIntegration(),
			Sentry.replayIntegration({
				maskAllText: false,
				blockAllMedia: false,
				maxReplayDuration: 10 * 60 * 1000,
				networkDetailAllowUrls: [BASE_URL],
			}),
		],
		tracesSampleRate: Number(SENTRY_TRACE_SAMPLE_RATE ?? 0),
		replaysSessionSampleRate: Number(SENTRY_REPLAY_SAMPLE_RATE ?? 0),
		replaysOnErrorSampleRate: 1.0,
		maxBreadcrumbs: 50,
		ignoreErrors: [
			'Minified Redux Toolkit',
			'This is single-lobby event. You are already in another lobby for this event',
			'Error joining lobby',
			'This function will work in Native App Powered By WebToNative',
			'Object captured as promise rejection with keys: error, isUnhandledError, meta',
			'Incorrect password',
			'Error submitting trade',
			'A trade for this market already exists.',
		],
	});
}

startTransition(() => {
	hydrateRoot(document, <HydratedRouter />, {
		onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
			console.warn('Uncaught error', error, errorInfo.componentStack);
		}),
		onCaughtError: Sentry.reactErrorHandler(),
		onRecoverableError: Sentry.reactErrorHandler(),
	});
});
